import React from 'react';

export default function SummaryCards({ summaryData = {} }) {
  const fmt  = (n)   => (n !== undefined && n !== null ? Number(n).toLocaleString('en-IN') : '0');
  const fmtR = (r)   => (r !== undefined && r !== null ? `${Number(r).toFixed(2)}%` : '0.00%');

  const cards = [
    {
      title: 'Approved Leads',
      value: fmt(summaryData.approvedLeads),
      sub: '100% of total approved',
      color: '#6366f1', bg: '#eef2ff',
      icon: (
        <svg style={{ width: 'auto' }} height="26" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      title: 'Reached Disbursement',
      value: fmt(summaryData.reachedDisbursement),
      sub: `${fmtR(summaryData.conversionRate)} conversion`,
      color: '#06b6d4', bg: '#ecfeff',
      icon: (
        <svg style={{ width: 'auto' }} height="26" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
      )
    },
    {
      title: 'Rejected Leads',
      value: fmt(summaryData.rejectedLeads),
      sub: `${fmtR(summaryData.rejectionRate)} rejected`,
      color: '#ef4444', bg: '#fef2f2',
      icon: (
        <svg style={{ width: 'auto' }} height="26" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
        </svg>
      )
    },
    {
      title: 'Expired Leads',
      value: fmt(summaryData.expiredLeads),
      sub: 'total expired cases',
      color: '#f59e0b', bg: '#fffbeb',
      icon: (
        <svg style={{ width: 'auto' }} height="26" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 15 15" />
        </svg>
      )
    },
    {
      title: 'Expiration Rate',
      value: fmtR(summaryData.expirationRate),
      sub: 'percentage expired',
      color: '#10b981', bg: '#ecfdf5',
      icon: (
        <svg style={{ width: 'auto' }} height="26" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      )
    }
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '14px',
      marginBottom: '20px'
    }}>
      {cards.map((c, i) => (
        <div key={i} style={{
          background: '#ffffff',
          borderRadius: '12px',
          border: '1px solid #e8ecf0',
          padding: '16px 18px',
          display: 'flex',
          flexDirection: 'row',      /* ← icon LEFT, text RIGHT (matches reference) */
          alignItems: 'flex-start',
          gap: '14px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          transition: 'box-shadow 0.18s',
          cursor: 'default'
        }}
          onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.09)'}
          onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'}
        >
          {/* Icon circle */}
          <div style={{
            width: '46px', height: '46px', borderRadius: '50%',
            background: c.bg, color: c.color,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, marginTop: '2px'
          }}>
            {c.icon}
          </div>

          {/* Text block */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '11.5px', color: '#64748b', fontWeight: '500', marginBottom: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {c.title}
            </div>
            <div style={{ fontSize: '22px', fontWeight: '800', color: '#0f172a', lineHeight: 1.15, marginBottom: '3px' }}>
              {c.value}
            </div>
            <div style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '500' }}>
              {c.sub}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
